import $ from 'jquery'
import {Loading} from 'element-ui'
import jQuery from 'jquery'

var Common = {};

Common.Utils = {
  /**
   * 手机号校验
   * @param value
   * @returns {boolean}
   */
  verifyMobileFormat: function (value) {
    if (value == null || value == 'null' || value == '' || typeof (value) == 'undefined') {
      this.$message.error('请您填写手机号码!');
      return false;
    }
    // 大陆
    // ^((\\+86\\-)?)1(3|5|7|8)\\d{9}$
    var mobileMainland = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/;
    // 香港
    // ^(\\+852\\-)(5|6|9)\\d{7}$
    var mobileHongKong = /^((\+852\-)(2|5|6|9)+\d{7})$/;
    // 澳门
    // ^(\\+853\\-)(6|8)\\d{7})$
    var mobileAomen = /^((\+853\-)(6|8)+\d{7})$/;
    // 台湾
    // ^(\\+886\\-)09\\d{8}$
    var mobileTaiwan = /^((\+886\-)(09)+\d{8})$/;
    return mobileMainland.test(value) || mobileHongKong.test(value) || mobileAomen.test(value) || mobileTaiwan.test(value)
  },
  /**
   * 克隆对象
   * @param obj
   * @returns {*}
   */
  clone: function (obj) {
    if (typeof (obj) != 'object') {
      return obj;
    }

    var re = {};
    if (obj.constructor == Array) {
      re = [];
    }

    for (var i in obj) {
      if (obj[i] == null) {
        re[i] = null;
      } else {
        re[i] = this.clone(obj[i]);
      }
    }
    return re;
  },

  /**
   * 判断是否为空对象
   * @param obj 需要判断的对象
   * @returns {boolean}
   */
  isEmpty: function (obj) {
    if (obj == '' || obj == null || obj == 'null'
      || typeof (obj) == undefined || obj == 'undefined') {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 判断是否是字符串
   * @param obj
   * @returns {boolean}
   */
  isString: function (obj) {
    return typeof obj === 'string';
  },
  /**
   * 判断是否为对象
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is an `Object` but not `null`.
   */
  isObject: function (value) {
    return value !== null && typeof value === 'object';
  },

  /**
   * 是否手机端
   */
  isMobileWeb: function () {
    var sUserAgent = navigator.userAgent.toLowerCase();
    if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
      return true;
    }
    return false;
  },
  /**
   * 判断是否为手机号码
   * @param value
   * @returns {boolean}
   */
  isMobile: function (value) {
    // 大陆
    // ^((\\+86\\-)?)1(3|5|7|8)\\d{9}$
    var mobileMainland = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
    // 香港
    // ^(\\+852\\-)(5|6|9)\\d{7}$
    var mobileHongKong = /^((\+852\-)(5|6|9)+\d{7})$/;
    // 澳门
    // ^(\\+853\\-)(6|8)\\d{7})$
    var mobileAomen = /^((\+853\-)(6|8)+\d{7})$/;
    // 台湾
    // ^(\\+886\\-)09\\d{8}$
    var mobileTaiwan = /^((\+886\-)(09)+\d{8})$/;
    return mobileMainland.test(value) || mobileHongKong.test(value) || mobileAomen.test(value) || mobileTaiwan.test(value);
  },

  getClientHeight() {
    var clientHeight = 0;
    if (document.body.clientHeight && document.documentElement.clientHeight) {
      var clientHeight = (document.body.clientHeight < document.documentElement.clientHeight) ?
        document.body.clientHeight : document.documentElement.clientHeight;
    } else {
      var clientHeight = (document.body.clientHeight > document.documentElement.clientHeight) ?
        document.body.clientHeight : document.documentElement.clientHeight;
    }
    return clientHeight;
  },

  animationFnc: function () {
    var pmh = window.innerHeight;
    var clientHeight = Common.Utils.getClientHeight();
    var animateDH = $(".animation, .animation1");
    var scrollTop = $(window).scrollTop() + pmh;
    if (animateDH.length > 0) {
      animateDH.each(function (i) {
        //判断当前元素否在窗口范围内
        var animateTop = $(this).offset().top;
        if (animateTop < clientHeight) {
          $(this).addClass("srcospcur");
        } else {
          if (animateTop < pmh)
            var animateTop = $(this).offset().top - pmh * 0.05;
          if (scrollTop > animateTop) {
            $(this).addClass("srcospcur");
          }
        }
      });
    }
  },
  /**
   * css 手机端显示隐藏
   */
  showMobileElem: function () {
    /* var mElem = $(".fit-mobile");
     var pElem = $(".fit-pc");
     if (this.isMobileWeb()) {
       mElem.css('cssText', 'display:block !important;');
       pElem.css('cssText', 'display:none !important;');
     } else {
       mElem.css('cssText', 'display:none !important');
       pElem.css('cssText', 'display:block !important');
     }*/
  },
};

/**
 * 加载器实例
 */
Common.Preloader = {
  show: function () {
    Loading.service({lock: true, text: '加载中...', spinner: 'el-icon-loading'});
  },
  hidden: function () {
    Loading.service({lock: true, text: '加载中...', spinner: 'el-icon-loading'}).close();
  }
};

/**
 * 请求操作实例
 */
Common.Request = {

  /**
   * 发送请求前，对URL的处理
   * @param vm vue实例对象
   * @param url 请求地址
   * @param urlData url参数
   * @returns {*}
   */
  beforeSend: function (vm, url, urlData) {
    if (!urlData) {
      urlData = {};
    }
    if (url.indexOf("http://") != 0 && url.indexOf("https://") != 0) {
      if (url.substring(0, 1) != '/') {
        url = "/" + url;
      }
      if (url.substring(url.length - url) == '/') {
        url = url.substring(url.length - 1);
      }
    }

    // 附加分页信息
    url = Common.PageDataUtil.pageDataHandleBefore(vm, url);
    url = Common.URL.appendURLData(url, vm, urlData);
    return url;
  },

  /**
   * 接收请求后，对response的处理
   * @param vm vue实例对象
   * @param response 响应结果
   * @param url 请求地址
   * @param postData post内容对象
   * @returns {*}
   */
  afterResponse: function (vm, response, url) {
    vm.loading = false;
    if (response == null) {
      return response;
    }
    if (typeof response.success === 'undefined') {
      var errorMsg = this.getResponseError(response);
      Common.PageOperator.showPromptMsg(vm, true, errorMsg, 'error');
      return "abort";
    }

    // 服务器代码内部运行错误、数据校验失败
    if (response.code == 3000) {
      var validatorMsgMap = response.error;
      if (!validatorMsgMap) {
        return result;
      }
      Common.PageOperator.showPromptMsg(vm, true, validatorMsgMap, 'error');
      return "abort";
    }
    if (response.code == 5005) {
      Common.PageOperator.showPromptMsg(vm, true, response.error, 'warning');

      vm.$router.push({path: '/login'});
      return "abort";
    }
    // 包含错误信息
    if (!response.success) {
      if (typeof response.error === 'string') {
        Common.PageOperator.showPromptMsg(vm, true, response.error, 'warning');
      }
      return "abort";
    }

    // 判断返回类型为ResultData类型，并且执行结果为成功时
    if (response.signle && response.dataList && response.dataList.length == 1) {
      var successMsg = response.dataList[0];
      if ((typeof successMsg === 'string') && /[\u0391-\uFFE5]+/.test(successMsg)) {
        Common.PageOperator.showPromptMsg(vm, true, successMsg, 'success');
      }
    }

    if (response.queryPage) {
      Common.PageDataUtil.pageDataHandleAfter(vm, response, url);
    }
    if (response.signle && response.dataList && response.dataList.length == 1) {
      return response.dataList[0];
    }
    if (response.data && response.data.length == 1) {
      var successMsg = response.data[0];
      if ((typeof successMsg === 'string') && /[\u0391-\uFFE5]+/.test(successMsg)) {
        Common.PageOperator.showPromptMsg(successMsg);
      }
      return successMsg;
    }
    if (url.indexOf('/api/grade/getGradeCoursePlanList') > -1 || url.indexOf('/certificate/list') > -1) {
      return response.data.pageData;
    }
    if (url.indexOf('/document/privateWriteToken') > -1 || url.indexOf('/api/grade/getHomeworkList') > -1) {
      return response.data;
    }

    return response.dataList;
  },

  getResponseError: function (response) {
    var errorMsg = (response == null ? "无法连接服务器" : response);
    if (response != null) {
      var errorMsg = response.message;
    }
    return errorMsg;
  }
};

/**
 * 页面常用操作
 */
Common.PageOperator =
  {

    /**
     * 展现带输入框的提示信息
     * @param vm
     * @param title 标题
     * @param message 提示信息
     * @param inputValidator 输入校验器 校验未通过可返回Boolean或者String
     * @param submitFunc 确定回调
     * @param cancelFunc 取消回调
     */
    showPromptInput: function (vm, title, message, inputValidator, submitFunc, cancelFunc) {
      vm.$prompt(message, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: inputValidator,
        inputType: 'textarea'
      })
        .then(function (result) {
          return submitFunc(result.value);
        })
        .catch(cancelFunc);
    },
    /**
     * 输入框提示信息扩展
     * inputValidator 输入框的校验函数
     * **/
    showPromptInputWithDefaultValue: function (vm, title, message, confirmButtonText, cancelButtonText, inputValue, inputValidator, submitFunc, cancelFunc) {
      vm.$prompt(message, title, {
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        inputType: 'textarea',
        inputValue: inputValue ? inputValue : '',
        inputValidator: inputValidator
      })
        .then(function (result) {
          return submitFunc(result.value);
        })
        .catch(cancelFunc);
    },
    /**
     * 展现提示信息
     * @param vm
     * @param showClose
     * @param message
     * @param type
     */
    showPromptMsg: function (vm, showClose, message, type) {
      vm.$message({
        showClose: showClose,
        message: message,
        dangerouslyUseHTMLString: true,
        type: type
      });
    },

    /**
     * 确认提示弹窗
     * @param vm
     * @param title
     * @param des
     * @param confirm 确认按钮
     * @param cancel 失败按钮
     * @param success 成功事件
     * @param fail 取消时间  可为 null
     */
    showConfirm: function (vm, title, des, confirm, cancel, success, fail) {
      var failFun = fail ? fail : function () {
      };
      vm.$confirm(des, title, {
        confirmButtonText: confirm,
        cancelButtonText: cancel,
        type: 'warning'
      }).then(success).catch(failFun);
    },
    /**
     * 展现HTML信息
     * @param vm
     * @param htmlDom
     */
    showPromptHtml: function (vm, htmlDom) {
      vm.$message({
        dangerouslyUseHTMLString: true,
        message: htmlDom
      });
    },

    /**
     * 检查错误提示， 并重置提交按钮
     * @param vm vue实例对象
     * @param resultData 响应结果
     * @param disableBtnName 按钮禁用vm名称
     * @returns {boolean}
     */
    checkResultData: function (vm, resultData, disableBtnName) {
      if (!resultData.success) {
        // 599表示错误消息已处理 5005表示用户未登录
        if (resultData.code != 599 && resultData.code != 5005) {
          var errorMsg = resultData.error;
          if (typeof (errorMsg) == "object" && errorMsg[0].failedDesc && typeof (errorMsg[0].failedDesc) == "object") {
            errorMsg = errorMsg[0].failedDesc[0];
          }
          this.showPromptMsg(vm, true, errorMsg, 'error');
        }
        if (disableBtnName != null && disableBtnName != undefined && vm.$data[disableBtnName]) {
          vm.$data[disableBtnName] = false;
        }
        return false;
      }
      return true;
    },

    /**
     * 显示通知消息
     * @param vm
     * @param isHtml
     * @param title
     * @param message
     */
    showNotifyMsg: function (vm, isHtml, title, message, time) {
      vm.$notify({
        title: title,
        message: message,
        dangerouslyUseHTMLString: isHtml,
        position: 'bottom-right',
        duration: time ? time : 5000
      })
    }
  };
Common.PageDataUtil = {

  //改变列表的的单个数据
  changeSimplePageData: function (data, index, changeModel) {
    console.log(typeof data);
    return data.splice(index, 1, changeModel);
  },

  // append the paramName=paramValue into param url
  appendParamToUrl: function (paramUrl, connectStr, vm, paramParentName, paramName) {
    if (vm[paramParentName] && vm[paramParentName] != ''
      && vm[paramParentName][paramName] && vm[paramParentName][paramName] != null) {
      paramUrl = paramUrl + connectStr + paramName + '=' + encodeURIComponent(vm[paramParentName][paramName]);
    }
    return paramUrl;
  },

  // handle the page data into url to request
  pageDataHandleBefore: function (vm, url) {
    var pageDataUrl = '';
    if (!vm.$data.pageInfo) {
      vm.$data.pageInfo = {};
    }

    pageDataUrl = this.appendParamToUrl(pageDataUrl, '&', vm, 'pageInfo', 'currentPage');
    pageDataUrl = this.appendParamToUrl(pageDataUrl, '&', vm, 'pageInfo', 'pageSize');
    pageDataUrl = this.appendParamToUrl(pageDataUrl, '&', vm, 'pageInfo', 'totalRows');
    pageDataUrl = this.appendParamToUrl(pageDataUrl, '&', vm, 'pageInfo', 'orderBy');
    pageDataUrl = this.appendParamToUrl(pageDataUrl, '&', vm, 'pageInfo', 'orderType');
    url = this.urlAppendParam(url, pageDataUrl);
    return url;
  },

  // append the params at the end of URL
  urlAppendParam: function (url, appendParam) {
    if (appendParam != '') {
      appendParam = appendParam.substring(1, appendParam.length);
      if (url.indexOf('?') > 0) {
        url = url + '&' + appendParam;
      } else {
        url = url + '?' + appendParam;
      }
    }
    return url;
  },

  // handle the page data from response
  pageDataHandleAfter: function (vm, response, url) {
    var queryPageInfo = response.queryPage;
    var pageInfo = vm.pageInfo;
    if (pageInfo && queryPageInfo) {
      for (var paramKey in queryPageInfo) {
        vm.$set(vm.pageInfo, 'currentPage', queryPageInfo['currentPage']);
        vm.$set(vm.pageInfo, 'pageSize', queryPageInfo['pageSize']);
        vm.$set(vm.pageInfo, 'totalRows', queryPageInfo['totalRows']);
        vm.$set(vm.pageInfo, 'orderBy', queryPageInfo['orderBy']);
        vm.$set(vm.pageInfo, 'orderType', queryPageInfo['orderType']);
      }
    }
  },

  /**
   * 重置分页并重新请求
   * @param vm
   */
  resetPageInfo: function (vm) {
    if (vm.pageInfo) {
      vm.$set(vm.pageInfo, "currentPage", 1);
      vm.$set(vm.pageInfo, "totalRows", -1);
    }
  },
  /**
   * 分页排序方法
   * @param vm
   * @param column  行对象，其中 column.order 排序(descending,ascending) ; column.prop 排序属性
   * @param prop
   * @param order
   * **/
  sortChangeFun: function (vm, column, prop, order) {
    vm.pageInfo.orderBy = column.prop;
    var orderType;
    if (column.order) {
      var index = column.order.indexOf('ending');
      orderType = column.order.slice(0, index);
    }
    vm.pageInfo.orderType = orderType;
    vm.pageInfo.getListFun();
  }
};
/**
 * URL参数实例
 */
Common.URL = {

  /**
   * 添加vm中的数据值
   * @param url 已存在的URL地址
   * @param vm vue实例对象
   * @param urlData 添加的URL参数
   * @returns {*}
   */
  appendURLData: function (url, vm, urlData) {
    if (!urlData) {
      return url;
    }
    for (var key in urlData) {
      var value = this.filterValue(urlData[key]);
      if (typeof (value) != 'undefined' && value != null) {
        url = this.appendURL(url, key, value);
      }
    }
    return url;
  },

  /**
   * 添加vm中的数据值
   * @param url 已存在的URL地址
   * @param vm vue实例对象
   * @param key vue实例对象key名称
   * @returns {*}
   */
  appendVmData: function (url, vm, key) {
    var value = this.getVmValue(key);
    if (value) {
      url = this.appendURL(url, key, value);
    }
    return url;
  },

  getUrlParm: function (name) {
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var tmpURL = document.location.href;
    var results = regex.exec(tmpURL);
    if (results == null) {
      return "";
    } else {
      return results[1];
    }
  },

  /**
   * 取得服务器地址
   * @returns {string}
   */
  getServerUrl: function () {
    var serverUrl = document.location.href;
    var firstPos = serverUrl.indexOf('/', 8);
    var secondPos = serverUrl.indexOf('/', firstPos + 1);
    serverUrl = serverUrl.substring(0, secondPos);
    return serverUrl;
  },

  /**
   * 取得域名
   * @returns {string}
   */
  getServerDomain: function () {
    var serverUrl = this.getServerUrl();
    var domain = serverUrl.substring("http://".length, serverUrl.length);
    if (domain.indexOf("/") > 0) {
      domain = domain.substring(0, domain.indexOf("/"));
    }
    return domain;
  },

  /**
   * 过滤value值，如果是空，null,undefined等，自动转换为空字符''
   * @param value 需要过滤的值
   * @returns {*}
   */
  filterValue: function (value) {
    if (value == null || value == 'null' || value == undefined || value == 'undefined') {
      return '';
    }
    return value;
  },

  /**
   * 取得vue实例中data中的值
   */
  getVmValue: function (vm, key) {
    var value = vm.$data[key];
    vm.$data[key] = this.filterValue(value);
    return vm.$data[key];
  },

  /**
   * 追加URL参数
   * @param url 已存在的URL数据
   * @param key 追加参数的key名称
   * @param value 追加的值, 可以是数组，基本类型，JSON对象等
   * @returns {*}
   */
  appendURL: function (url, key, value) {
    if (typeof (value) == 'undefined' || value == null) {
      value = "";
    }

    var values = [];
    if (jQuery.isArray(value)) {
      values = value;
    } else {
      values.push(value);
    }

    for (var pos in values) {
      var urlKey = key;
      var urlValue = values[pos];

      var isJSONObj = typeof (urlValue) == "object" && Object.prototype.toString.call(urlValue).toLowerCase() == "[object object]" && !urlValue.length;
      if (isJSONObj) {
        for (var jsonKey in urlValue) {
          this.appendEncodeURL(url, jsonKey, urlValue[jsonKey]);
        }
        return url;
      }

      return this.appendEncodeURL(url, urlKey, urlValue);
    }
    return url;
  },

  /**
   * 追加URL参数键值
   * @param url 已存在的URL参数
   * @param urlKey 追加URL参数名
   * @param urlValue 追加URL参数值
   * @returns {*}
   */
  appendEncodeURL: function (url, urlKey, urlValue) {
    if (url.indexOf('?') > 0) {
      url = url + '&' + urlKey + '=' + encodeURIComponent(urlValue);
    } else {
      url = url + '?' + urlKey + '=' + encodeURIComponent(urlValue);
    }
    return url;
  }
};


export default Common;



// WEBPACK FOOTER //
// ./src/js/common.js